<template>
  <div class="mapAlignFormPanel">
    <div class="contentBox">
      <div class="panelTitle">模型视图</div>
      <div class="toolBar">
        <div class="leftBox">
          <i @click="$emit('setZoom', -1)">
            <svg-icon icon-class="scalePlus" class="scalePlus" />
          </i>
          <i @click="$emit('setZoom', 1)">
            <svg-icon icon-class="scaleMinus" class="scaleMinus" />
          </i>
          <i @click="$emit('miniRotate', (-Math.PI / 180))">
            <svg-icon icon-class="rotateLeft" class="rotateLeft" />
          </i>
          <i @click="$emit('miniRotate', (Math.PI / 180))">
            <svg-icon icon-class="rotateRight" class="rotateRight" />
          </i>
          <!-- <i @click="$emit('download3DImage')">
            <svg-icon icon-class="uploadSvg" class="downloadSvg" />
          </i> -->
        </div>
      </div>
      <div v-if="source == 'cmap'">
        <div class="panelTitle">对齐数据</div>
        <div class="jsonViewer">
          <json-viewer theme="my-awesome-json-theme" copyable :value="jsonData"></json-viewer>
        </div>
        <div class="panelTitle">自定义模型对齐</div>
        <div>
          <el-input style="{float: left; width:30%;}"
                    size="mini"
                    placeholder="长度"
                    v-model="width" />
          <el-input style="{float: left; width:30%;}"
                    size="mini"
                    placeholder="宽度"
                    v-model="height" />
          <el-button style="{float: left; width:30%;}" size="mini" @click="onSizeConfirm">生成</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LayerManager, eventHub } from '@aibee/vincent';
import JsonViewer from 'vue-json-viewer';
import { } from '@/api/map';

export default {
  name: 'mapAlignFormPanel',
  components: { JsonViewer },
  props: {
    jsonData: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    source(val) {
      this.width = 0;
      this.height = 0;
    },
  },
  computed: {
    source() {
      return this.$route.params.source;
    },
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
  },
  data() {
    return {
      width: '',
      height: '',
    };
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {
    // console.log('update', this.$props.maxSize);
    // this.maxSize = '';
  },
  methods: {
    onSizeConfirm(e) {
      // console.log(this.maxLength);
      const width = Number(this.width);
      const height = Number(this.height);
      if (width && height) {
        this.$emit('onSizeConfirm', width, height);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mapAlignFormPanel {
  width: 280px;
  height: 100%;
  background-color: #1c1c1e;
  box-shadow: 1px 2px 2px 232323;
  z-index: 10;
  padding: 0px 30px 0 30px;
  box-sizing: border-box;
  overflow: auto;
  .contentBox {
    .panelTitle {
      color: #d8d8d8;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .jsonViewer {
      margin-bottom: 24px;
    }
    .toolBar {
      width: 100%;
      background-color: #2c2c2e;
      height: 40px;
      border-radius: 40px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .svg-icon {
        fill: #fff;
        font-size: 14px;
        width: 30px;
        height: 30px;
        margin-right: 10px;
        cursor: pointer;
        &:hover {
          fill: #307bf6;
        }
      }
      .active {
        fill: #307bf6;
      }
      .disable {
        fill: #666 !important;
      }
      .downloadSvg {
        transform: rotateZ(180deg);
      }
    }
    .my-awesome-json-theme {
      background: #2c2c2e;
      white-space: nowrap;
      color: #fff;
      font-size: 14px;
      font-family: Consolas, Menlo, Courier, monospace;

      .jv-ellipsis {
        color: #999;
        background-color: #eee;
        display: inline-block;
        line-height: 0.9;
        font-size: 0.9em;
        padding: 0px 4px 2px 4px;
        border-radius: 3px;
        vertical-align: 2px;
        cursor: pointer;
        user-select: none;
      }
      .jv-button {
        color: #49b3ff;
      }
      .jv-key {
        color: #111111;
      }
      .jv-item {
        &.jv-array {
          color: #111111;
        }
        &.jv-boolean {
          color: #fc1e70;
        }
        &.jv-function {
          color: #067bca;
        }
        &.jv-number {
          color: #fc1e70;
        }
        &.jv-object {
          color: #111111;
        }
        &.jv-undefined {
          color: #e08331;
        }
        &.jv-string {
          color: #42b983;
          word-break: break-word;
          white-space: normal;
        }
      }
      .jv-code {
        .jv-toggle {
          &:before {
            padding: 0px 2px;
            border-radius: 2px;
          }
          &:hover {
            &:before {
              background: #eee;
            }
          }
        }
      }
    }
  }
}
</style>
